import { render, staticRenderFns } from "./ownDetails.vue?vue&type=template&id=8fe671a8&scoped=true&"
import script from "./ownDetails.vue?vue&type=script&lang=js&"
export * from "./ownDetails.vue?vue&type=script&lang=js&"
import style0 from "./ownDetails.vue?vue&type=style&index=0&id=8fe671a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe671a8",
  null
  
)

component.options.__file = "ownDetails.vue"
export default component.exports